/**
 * Footwear Product Template - JavaScript
 * Gallery behavior matches apparel template exactly:
 *   - Horizontal flex scroll, 2 images visible on desktop, 1 on mobile
 *   - Arrow navigation, thumbnail clicks scroll gallery
 *   - Mobile dot indicators, swipe via scroll-snap
 *   - Click-to-zoom, filename-based color filtering
 *   - Scroll sync for thumbnails/dots
 */

(function() {
  'use strict';

  var productJSON = document.getElementById('fw-product-json');
  if (!productJSON) return;
  var product = JSON.parse(productJSON.textContent);
  var variants = product.variants;

  /* DOM references */
  var form = document.getElementById('fw-product-form');
  var variantSelect = document.getElementById('fw-variant-select');
  var atcBtn = document.getElementById('fw-atc-btn');
  var atcText = document.getElementById('fw-atc-text');
  var priceBlock = document.getElementById('fw-price-block');
  var galleryMain = document.getElementById('fw-gallery-main');
  var thumbnails = document.getElementById('fw-thumbnails');
  var dotsContainer = document.getElementById('fw-gallery-dots');
  var prevArrow = document.getElementById('fw-gallery-prev');
  var nextArrow = document.getElementById('fw-gallery-next');

  // Size panel
  var sizeTrigger = document.getElementById('fw-size-trigger');
  var sizePanel = document.getElementById('fw-size-panel');
  var sizePanelClose = document.getElementById('fw-size-panel-close');
  var sizeOverlay = document.getElementById('fw-size-overlay');
  var sizeTriggerText = document.getElementById('fw-size-trigger-text');

  // Cart drawer
  var cartDrawer = document.getElementById('fw-cart-drawer');
  var cartOverlay = document.getElementById('fw-cart-overlay');
  var cartClose = document.getElementById('fw-cart-close');
  var cartItems = document.getElementById('fw-cart-items');
  var cartEmpty = document.getElementById('fw-cart-empty');
  var cartTotal = document.getElementById('fw-cart-total');
  var cartFooter = document.getElementById('fw-cart-footer');

  // Track selected options
  var selectedOptions = [];
  product.options.forEach(function(opt, i) {
    var currentVariant = product.selected_variant || variants[0];
    selectedOptions[i] = currentVariant['option' + (i + 1)];
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* Detect which option index is "Color" */
  var colorOptionIndex = -1;
  if (product.options) {
    for (var oi = 0; oi < product.options.length; oi++) {
      var optName = (product.options[oi] || '').toLowerCase().trim();
      if (optName === 'color' || optName === 'colour') { colorOptionIndex = oi; break; }
    }
  }

  var currentColorFilter = null;
  var currentVisibleImages = [];
  var currentVisibleThumbs = [];
  var currentSlideIndex = 0;

  /* ==========================================
     FILENAME-BASED COLOR MATCHING
     ========================================== */
  function normalizeForMatch(str) {
    return (str || '').toLowerCase().replace(/[\s\-_]+/g, '');
  }

  function filenameMatchesColor(filename, colorValue) {
    var fnameClean = normalizeForMatch(filename.replace(/\.[^.]+$/, ''));
    var colorClean = normalizeForMatch(colorValue);
    if (!fnameClean || !colorClean) return false;
    return fnameClean.indexOf(colorClean) === 0;
  }

  /* ==========================================
     IMAGE FILTERING BY COLOR
     ========================================== */
  function filterGalleryByColor(colorValue) {
    if (!galleryMain || !thumbnails) return;
    if (!colorValue) { showAllImages(); return; }

    currentColorFilter = colorValue;

    var allImages = galleryMain.querySelectorAll('.fw-gallery__image');
    var allThumbs = thumbnails.querySelectorAll('.fw-gallery__thumbnail');

    var matchCount = 0;
    for (var c = 0; c < allImages.length; c++) {
      var fn = allImages[c].getAttribute('data-image-filename') || '';
      if (filenameMatchesColor(fn, colorValue)) matchCount++;
    }

    if (matchCount === 0) {
      showAllImages(allImages, allThumbs);
      return;
    }

    currentVisibleImages = [];
    for (var i = 0; i < allImages.length; i++) {
      var imgFn = allImages[i].getAttribute('data-image-filename') || '';
      if (filenameMatchesColor(imgFn, colorValue)) {
        allImages[i].style.display = '';
        allImages[i].classList.remove('fw-gallery__image--hidden');
        currentVisibleImages.push(allImages[i]);
      } else {
        allImages[i].style.display = 'none';
        allImages[i].classList.add('fw-gallery__image--hidden');
      }
    }

    currentVisibleThumbs = [];
    for (var k = 0; k < allThumbs.length; k++) {
      var thumbFn = allThumbs[k].getAttribute('data-image-filename') || '';
      if (filenameMatchesColor(thumbFn, colorValue)) {
        allThumbs[k].style.display = '';
        allThumbs[k].classList.remove('fw-gallery__thumbnail--hidden');
        currentVisibleThumbs.push(allThumbs[k]);
      } else {
        allThumbs[k].style.display = 'none';
        allThumbs[k].classList.add('fw-gallery__thumbnail--hidden');
      }
    }

    currentSlideIndex = 0;
    requestAnimationFrame(function() {
      scrollToVisibleIndex(0, false);
      highlightVisibleThumb(0);
      buildDots();
      updateArrowState();
    });
  }

  function showAllImages(allImages, allThumbs) {
    if (!allImages) allImages = galleryMain ? galleryMain.querySelectorAll('.fw-gallery__image') : [];
    if (!allThumbs) allThumbs = thumbnails ? thumbnails.querySelectorAll('.fw-gallery__thumbnail') : [];

    currentVisibleImages = [];
    for (var i = 0; i < allImages.length; i++) {
      allImages[i].style.display = '';
      allImages[i].classList.remove('fw-gallery__image--hidden');
      currentVisibleImages.push(allImages[i]);
    }
    currentVisibleThumbs = [];
    for (var j = 0; j < allThumbs.length; j++) {
      allThumbs[j].style.display = '';
      allThumbs[j].classList.remove('fw-gallery__thumbnail--hidden');
      currentVisibleThumbs.push(allThumbs[j]);
    }

    currentSlideIndex = 0;
    requestAnimationFrame(function() {
      scrollToVisibleIndex(0, false);
      highlightVisibleThumb(0);
      buildDots();
      updateArrowState();
    });
  }

  /* ==========================================
     GALLERY NAVIGATION
     ========================================== */
  function scrollToVisibleIndex(visIndex, smooth) {
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    if (visIndex < 0 || visIndex >= visible.length) return;
    currentSlideIndex = visIndex;
    var target = visible[visIndex];
    var behavior = smooth !== false ? 'smooth' : 'auto';
    galleryMain.scrollTo({ left: target.offsetLeft, behavior: behavior });
  }

  function getVisibleImages() {
    if (!galleryMain) return [];
    return Array.from(galleryMain.querySelectorAll(
      '.fw-gallery__image:not(.fw-gallery__image--hidden)'
    ));
  }

  function highlightVisibleThumb(visIndex) {
    var allThumbs = thumbnails ? thumbnails.querySelectorAll('.fw-gallery__thumbnail') : [];
    for (var i = 0; i < allThumbs.length; i++) {
      allThumbs[i].classList.remove('fw-gallery__thumbnail--active');
    }
    var visibleThumbs = currentVisibleThumbs.length ? currentVisibleThumbs :
      Array.from(allThumbs).filter(function(t) {
        return !t.classList.contains('fw-gallery__thumbnail--hidden');
      });
    if (visIndex >= 0 && visIndex < visibleThumbs.length) {
      visibleThumbs[visIndex].classList.add('fw-gallery__thumbnail--active');
      visibleThumbs[visIndex].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  }

  /* Mobile dot indicators */
  function buildDots() {
    if (!dotsContainer) return;
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    var isMobile = window.innerWidth < 750;
    if (!isMobile || visible.length <= 1) {
      dotsContainer.innerHTML = '';
      dotsContainer.style.display = 'none';
      return;
    }
    dotsContainer.style.display = 'flex';
    var html = '';
    for (var i = 0; i < visible.length; i++) {
      html += '<span class="fw-gallery__dot' +
        (i === currentSlideIndex ? ' fw-gallery__dot--active' : '') +
        '" data-dot-index="' + i + '"></span>';
    }
    dotsContainer.innerHTML = html;
  }

  function updateDotActive(visIndex) {
    if (!dotsContainer) return;
    var dots = dotsContainer.querySelectorAll('.fw-gallery__dot');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('fw-gallery__dot--active', i === visIndex);
    }
  }

  function getSlideStep() {
    if (!galleryMain) return 0;
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    if (!visible.length) return 0;
    var imageWidth = visible[0].offsetWidth;
    var gap = 8;
    if (window.innerWidth < 750) return imageWidth;
    return (imageWidth + gap) * 2;
  }

  function scrollGalleryBy(delta) {
    if (!galleryMain) return;
    galleryMain.scrollBy({ left: delta, behavior: 'smooth' });
    setTimeout(function() {
      syncScrollToSlideIndex();
      updateArrowState();
    }, 350);
  }

  function updateArrowState() {
    if (!galleryMain || !prevArrow || !nextArrow) return;
    var maxScroll = galleryMain.scrollWidth - galleryMain.clientWidth;
    prevArrow.disabled = galleryMain.scrollLeft <= 2;
    nextArrow.disabled = galleryMain.scrollLeft >= maxScroll - 2;
  }

  function syncScrollToSlideIndex() {
    if (!galleryMain) return;
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    var scrollLeft = galleryMain.scrollLeft;
    var closestIdx = 0;
    var closestDist = Infinity;
    for (var i = 0; i < visible.length; i++) {
      var dist = Math.abs(visible[i].offsetLeft - scrollLeft);
      if (dist < closestDist) {
        closestDist = dist;
        closestIdx = i;
      }
    }
    currentSlideIndex = closestIdx;
    highlightVisibleThumb(closestIdx);
    updateDotActive(closestIdx);
  }

  function showGalleryImageByGlobalIndex(globalIndex) {
    if (!galleryMain) return;
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    for (var i = 0; i < visible.length; i++) {
      if (parseInt(visible[i].getAttribute('data-index'), 10) === globalIndex) {
        scrollToVisibleIndex(i, true);
        highlightVisibleThumb(i);
        updateDotActive(i);
        return;
      }
    }
  }

  /* ==========================================
     VARIANT UPDATE
     ========================================== */
  function updateVariant() {
    var matchedVariant = variants.find(function(v) {
      return product.options.every(function(opt, i) {
        return v['option' + (i + 1)] === selectedOptions[i];
      });
    });

    if (!matchedVariant) return;

    if (variantSelect) variantSelect.value = matchedVariant.id;

    var url = new URL(window.location);
    url.searchParams.set('variant', matchedVariant.id);
    window.history.replaceState({}, '', url);

    // Update price
    if (priceBlock) {
      var priceHTML = '';
      if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
        priceHTML = '<span class="fw-product__compare-price">' + formatMoney(matchedVariant.compare_at_price) + '</span>';
        priceHTML += '<span class="fw-product__price">' + formatMoney(matchedVariant.price) + '</span>';
        var savings = Math.round((1 - matchedVariant.price / matchedVariant.compare_at_price) * 100);
        priceHTML += '<span class="fw-product__sale-tag">-' + savings + '%</span>';
      } else {
        priceHTML = '<span class="fw-product__price">' + formatMoney(matchedVariant.price) + '</span>';
      }
      priceBlock.innerHTML = priceHTML;
    }

    // Update ATC
    if (atcBtn && atcText) {
      if (matchedVariant.available) {
        atcBtn.disabled = false;
        atcText.textContent = 'Add to bag';
      } else {
        atcBtn.disabled = true;
        atcText.textContent = 'Sold out';
      }
    }

    /* Filter gallery by color */
    if (colorOptionIndex >= 0 && selectedOptions[colorOptionIndex]) {
      filterGalleryByColor(selectedOptions[colorOptionIndex]);
    }
  }

  /* ==========================================
     COLOR SWATCH SELECTION
     ========================================== */
  document.querySelectorAll('.fw-color-swatch').forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      var optionIndex = parseInt(this.dataset.optionIndex);
      var value = this.dataset.value;

      selectedOptions[optionIndex] = value;

      this.closest('.fw-color-selector__grid').querySelectorAll('.fw-color-swatch').forEach(function(s) {
        s.classList.remove('fw-color-swatch--active');
      });
      this.classList.add('fw-color-swatch--active');

      var colorNameEl = document.getElementById('fw-color-name');
      if (colorNameEl) colorNameEl.textContent = value;

      updateVariant();
    });
  });

  /* ==========================================
     SIZE SELECTOR PANEL
     ========================================== */
  function openSizePanel() {
    if (sizePanel) sizePanel.classList.add('fw-size-panel--open');
    if (sizeOverlay) sizeOverlay.classList.add('fw-size-overlay--open');
    if (sizeTrigger) sizeTrigger.classList.add('fw-size-trigger--open');
    document.body.style.overflow = 'hidden';
  }

  function closeSizePanel() {
    if (sizePanel) sizePanel.classList.remove('fw-size-panel--open');
    if (sizeOverlay) sizeOverlay.classList.remove('fw-size-overlay--open');
    if (sizeTrigger) sizeTrigger.classList.remove('fw-size-trigger--open');
    document.body.style.overflow = '';
  }

  if (sizeTrigger) sizeTrigger.addEventListener('click', openSizePanel);
  if (sizePanelClose) sizePanelClose.addEventListener('click', closeSizePanel);
  if (sizeOverlay) sizeOverlay.addEventListener('click', closeSizePanel);

  document.querySelectorAll('.fw-size-option').forEach(function(option) {
    option.addEventListener('click', function() {
      if (this.classList.contains('fw-size-option--unavailable')) return;

      var optionIndex = parseInt(this.dataset.optionIndex);
      var value = this.dataset.value;

      selectedOptions[optionIndex] = value;

      document.querySelectorAll('.fw-size-option').forEach(function(o) {
        o.classList.remove('fw-size-option--active');
      });
      this.classList.add('fw-size-option--active');

      if (sizeTriggerText) sizeTriggerText.textContent = 'Size ' + value;

      closeSizePanel();
      updateVariant();
    });
  });

  /* ==========================================
     GENDER TOGGLE
     ========================================== */
  document.querySelectorAll('.fw-gender-toggle__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.fw-gender-toggle__btn').forEach(function(b) {
        b.classList.remove('fw-gender-toggle__btn--active');
      });
      this.classList.add('fw-gender-toggle__btn--active');
    });
  });

  /* ==========================================
     AJAX ADD TO CART
     ========================================== */
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      if (!variantSelect) return;
      addToCart(variantSelect.value, 1);
    });
  }

  function addToCart(variantId, quantity) {
    if (atcBtn) atcBtn.classList.add('fw-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity || 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      if (atcBtn) atcBtn.classList.remove('fw-loading');
      refreshCartDrawer();
      openCartDrawer();
      updateCartCount();
    })
    .catch(function(err) {
      if (atcBtn) atcBtn.classList.remove('fw-loading');
      console.error('Add to cart error:', err);
    });
  }

  /* ==========================================
     CART DRAWER
     ========================================== */
  function openCartDrawer() {
    /* Unified cart experience: always open the site-wide drawer when present */
    if (window.CozyCartDrawer) { window.CozyCartDrawer.refresh(); window.CozyCartDrawer.open(); return; }

    if (cartDrawer) cartDrawer.classList.add('fw-cart-drawer--open');
    if (cartOverlay) { cartOverlay.style.display = 'block'; cartOverlay.classList.add('fw-cart-overlay--open'); }
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('fw-cart-drawer--open');
    if (cartOverlay) {
      cartOverlay.classList.remove('fw-cart-overlay--open');
      setTimeout(function() { cartOverlay.style.display = 'none'; }, 300);
    }
    document.body.style.overflow = '';
  }

  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) {
    cartOverlay.addEventListener('click', function(e) {
      if (e.target === cartOverlay) closeCartDrawer();
    });
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCartDrawer(cart); })
      .catch(function(err) { console.error('Cart fetch error:', err); });
  }

  function renderCartDrawer(cart) {
    if (!cartItems) return;

    if (!cart.items || cart.items.length === 0) {
      cartItems.innerHTML = '';
      if (cartEmpty) cartEmpty.style.display = 'block';
      if (cartFooter) cartFooter.style.display = 'none';
      return;
    }

    if (cartEmpty) cartEmpty.style.display = 'none';
    if (cartFooter) cartFooter.style.display = 'block';

    var html = '';
    cart.items.forEach(function(item) {
      var variantInfo = [];
      if (item.variant_options) {
        item.variant_options.forEach(function(opt) {
          if (opt !== 'Default Title') variantInfo.push(opt);
        });
      }

      html += '<div class="fw-cart-item" data-key="' + item.key + '">' +
        '<img class="fw-cart-item__image" src="' + (item.image || item.featured_image.url) + '" alt="' + item.title + '" width="80" height="80">' +
        '<div class="fw-cart-item__details">' +
          '<h4 class="fw-cart-item__title">' + item.product_title + '</h4>' +
          '<p class="fw-cart-item__variant">' + variantInfo.join(' \u00b7 ') + '</p>' +
          '<div class="fw-cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="fw-cart-item__quantity">' +
            '<button class="fw-cart-item__qty-btn" data-action="decrease" data-key="' + item.key + '" aria-label="Decrease quantity">\u2212</button>' +
            '<span class="fw-cart-item__qty-value">' + item.quantity + '</span>' +
            '<button class="fw-cart-item__qty-btn" data-action="increase" data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<button class="fw-cart-item__remove" data-action="remove" data-key="' + item.key + '" aria-label="Remove item">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>';
    });

    cartItems.innerHTML = html;
    if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
  }

  function handleCartItemClick(e) {
    var target = e.target.closest('[data-action]');
    if (!target) return;
    var action = target.getAttribute('data-action');
    var key = target.getAttribute('data-key');
    if (!key) return;
    if (action === 'remove') updateCartItem(key, 0);
    else if (action === 'decrease') {
      var qtyEl = target.parentElement.querySelector('.fw-cart-item__qty-value');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      updateCartItem(key, Math.max(0, qty - 1));
    } else if (action === 'increase') {
      var qtyEl2 = target.parentElement.querySelector('.fw-cart-item__qty-value');
      var qty2 = qtyEl2 ? parseInt(qtyEl2.textContent, 10) : 1;
      updateCartItem(key, qty2 + 1);
    }
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCartDrawer(cart); updateCartCount(); })
    .catch(function(err) { console.error('Cart update error:', err); });
  }

  function updateCartCount() {
    /* Re-render the header cart-icon-bubble section so the count badge is
       created/removed and the empty<->full cart icon swaps correctly, even
       when the page loaded with an empty cart. Authoritative from the server. */
    fetch('/?sections=cart-icon-bubble')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var markup = data && data['cart-icon-bubble'];
        if (!markup) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = markup;
        var fresh = tmp.querySelector('#shopify-section-cart-icon-bubble') || tmp.firstElementChild;
        var icon = document.getElementById('cart-icon-bubble');
        if (icon && fresh) icon.innerHTML = fresh.innerHTML;
      })
      .catch(function() {});
  }

  /* ==========================================
     EVENT BINDINGS
     ========================================== */

  // Gallery arrows
  if (prevArrow) {
    prevArrow.addEventListener('click', function() { scrollGalleryBy(-getSlideStep()); });
  }
  if (nextArrow) {
    nextArrow.addEventListener('click', function() { scrollGalleryBy(getSlideStep()); });
  }

  // Thumbnail clicks
  if (thumbnails) {
    thumbnails.addEventListener('click', function(e) {
      var thumb = e.target.closest('.fw-gallery__thumbnail');
      if (!thumb) return;
      var globalIndex = parseInt(thumb.getAttribute('data-index'), 10);
      showGalleryImageByGlobalIndex(globalIndex);
    });
  }

  // Dot clicks
  if (dotsContainer) {
    dotsContainer.addEventListener('click', function(e) {
      var dot = e.target.closest('.fw-gallery__dot');
      if (!dot) return;
      var dotIndex = parseInt(dot.getAttribute('data-dot-index'), 10);
      scrollToVisibleIndex(dotIndex, true);
      highlightVisibleThumb(dotIndex);
      updateDotActive(dotIndex);
    });
  }

  // Click-to-zoom on gallery images
  if (galleryMain) {
    galleryMain.addEventListener('click', function(e) {
      var imageDiv = e.target.closest('.fw-gallery__image');
      if (!imageDiv) return;
      if (imageDiv.classList.contains('fw-gallery__image--zoomed')) {
        imageDiv.classList.remove('fw-gallery__image--zoomed');
      } else {
        galleryMain.querySelectorAll('.fw-gallery__image--zoomed')
          .forEach(function(el) { el.classList.remove('fw-gallery__image--zoomed'); });
        imageDiv.classList.add('fw-gallery__image--zoomed');
      }
    });

    // Scroll sync: update thumbnails/dots when user scrolls
    var scrollSyncTimeout;
    galleryMain.addEventListener('scroll', function() {
      clearTimeout(scrollSyncTimeout);
      scrollSyncTimeout = setTimeout(function() {
        syncScrollToSlideIndex();
        updateArrowState();
      }, 100);
    }, { passive: true });
  }

  // ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var zoomed = document.querySelector('.fw-gallery__image--zoomed');
      if (zoomed) zoomed.classList.remove('fw-gallery__image--zoomed');
      closeCartDrawer();
      closeSizePanel();
    }
  });

  // Cart item clicks (delegated)
  if (cartItems) { cartItems.addEventListener('click', handleCartItemClick); }

  // Header cart icon → open drawer
  document.addEventListener('click', function(e) {
    var cartLink = e.target.closest('a[href="/cart"], .header__icon--cart, [data-cart-toggle]');
    if (cartLink) {
      e.preventDefault();
      e.stopPropagation();
      refreshCartDrawer();
      openCartDrawer();
    }
  });

  // Resize handler
  var resizeDebounce;
  window.addEventListener('resize', function() {
    clearTimeout(resizeDebounce);
    resizeDebounce = setTimeout(function() {
      buildDots();
      updateArrowState();
    }, 200);
  });

  /* ==========================================
     VIDEO BILLBOARD
     ========================================== */
  var videoPauseBtn = document.getElementById('fw-video-pause');
  var billboardVideo = document.getElementById('fw-billboard-video');

  if (videoPauseBtn && billboardVideo) {
    videoPauseBtn.addEventListener('click', function() {
      if (billboardVideo.paused) {
        billboardVideo.play();
        videoPauseBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';
      } else {
        billboardVideo.pause();
        videoPauseBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>';
      }
    });
  }

  /* ==========================================
     RELATED PRODUCTS CAROUSEL
     ========================================== */
  var relatedTrack = document.getElementById('fw-related-track');
  var relatedPrev = document.getElementById('fw-related-prev');
  var relatedNext = document.getElementById('fw-related-next');
  var relatedProgress = document.getElementById('fw-related-progress-bar');
  var relatedOffset = 0;

  function getRelatedCardWidth() {
    if (!relatedTrack) return 0;
    var card = relatedTrack.querySelector('.fw-product-card');
    if (!card) return 0;
    var style = window.getComputedStyle(relatedTrack);
    var gap = parseInt(style.gap) || 20;
    return card.offsetWidth + gap;
  }

  function getRelatedMaxOffset() {
    if (!relatedTrack) return 0;
    var cards = relatedTrack.querySelectorAll('.fw-product-card');
    var cardWidth = getRelatedCardWidth();
    var visibleWidth = relatedTrack.parentElement.offsetWidth;
    var totalWidth = cards.length * cardWidth - (parseInt(window.getComputedStyle(relatedTrack).gap) || 20);
    return Math.max(0, totalWidth - visibleWidth);
  }

  function updateRelatedCarousel() {
    if (!relatedTrack) return;
    relatedTrack.style.transform = 'translateX(-' + relatedOffset + 'px)';
    if (relatedPrev) relatedPrev.disabled = relatedOffset <= 0;
    var maxOff = getRelatedMaxOffset();
    if (relatedNext) relatedNext.disabled = relatedOffset >= maxOff;
    if (relatedProgress && maxOff > 0) {
      var progress = ((relatedOffset / maxOff) * 67) + 33;
      relatedProgress.style.width = Math.min(100, progress) + '%';
    }
  }

  if (relatedPrev) {
    relatedPrev.addEventListener('click', function() {
      var step = getRelatedCardWidth();
      relatedOffset = Math.max(0, relatedOffset - step);
      updateRelatedCarousel();
    });
  }

  if (relatedNext) {
    relatedNext.addEventListener('click', function() {
      var step = getRelatedCardWidth();
      var maxOff = getRelatedMaxOffset();
      relatedOffset = Math.min(maxOff, relatedOffset + step);
      updateRelatedCarousel();
    });
  }

  if (relatedTrack) {
    var relTouchStart = 0;
    relatedTrack.addEventListener('touchstart', function(e) {
      relTouchStart = e.changedTouches[0].screenX;
    }, { passive: true });
    relatedTrack.addEventListener('touchend', function(e) {
      var relTouchEnd = e.changedTouches[0].screenX;
      var diff = relTouchStart - relTouchEnd;
      if (Math.abs(diff) > 50) {
        var step = getRelatedCardWidth();
        var maxOff = getRelatedMaxOffset();
        if (diff > 0) relatedOffset = Math.min(maxOff, relatedOffset + step);
        else relatedOffset = Math.max(0, relatedOffset - step);
        updateRelatedCarousel();
      }
    });
  }

  updateRelatedCarousel();
  window.addEventListener('resize', function() {
    relatedOffset = Math.min(relatedOffset, getRelatedMaxOffset());
    updateRelatedCarousel();
  });

  /* ==========================================
     INIT
     ========================================== */
  (function init() {
    if (galleryMain) {
      currentVisibleImages = Array.from(galleryMain.querySelectorAll('.fw-gallery__image'));
    }
    if (thumbnails) {
      currentVisibleThumbs = Array.from(thumbnails.querySelectorAll('.fw-gallery__thumbnail'));
    }

    /* Filter to initially selected color on page load */
    if (colorOptionIndex >= 0) {
      var activeSwatch = document.querySelector(
        '.fw-color-swatch--active[data-option-index="' + colorOptionIndex + '"]'
      );
      if (activeSwatch) {
        var initialColor = activeSwatch.getAttribute('data-value');
        if (initialColor) filterGalleryByColor(initialColor);
      }
    }

    if (currentColorFilter === null) showAllImages();

    updateCartCount();
    buildDots();
    updateArrowState();
  })();
})();
